import { memo } from 'react';

import { useDismissableBanner } from 'my-core/hooks';
import { isStudySessionListable } from 'my-core/study-session-utils';

import GradeBoosterBanner from './GradeBoosterBanner';

export default memo(function GradeBoosterBannerCtnr({ assessment, course, studySessions }) {
  const [hidden, dismissCTA] = useDismissableBanner('grade_booster_banner', 3 * 24 * 3600 * 1000);

  const unregisteredStudySessions = studySessions.filter(
    ss => isStudySessionListable(ss) && !ss.current_user_study_session_user,
  );
  if (hidden || !unregisteredStudySessions.length) return null;
  return (
    <GradeBoosterBanner
      assessment={assessment}
      course={course}
      onClose={dismissCTA}
      studySessions={unregisteredStudySessions}
    />
  );
});
